import React from "react";
import { connect } from "react-redux";

class PromoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section className={"promo-section ptb-100 " + (this.props.removeTopMargin ? '' : 'mt-5')}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-10">
                <div className="section-heading mb-5">
                  <span className="badge badge-primary badge-pill">
                    Virtual Event
                  </span>
                  <h5 className="h5 mt-3 mb-6">
                    We will help keep you up to date with Carolina Elite's event via our suite of apps.
                  </h5>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-sm-6 mb-lg-0">
                <div className="card single-promo-card single-promo-hover">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-import icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Access</h5>
                      <p className="text-muted mb-0">
                      Use our easy to use Desktop, Mobile, or TV App to stay up to date.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-layers icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Features</h5>
                      <p className="text-muted mb-0">
                        This event only has a limited set of features including a video live stream. 
                      </p>
                    </div>
                    {/* Most weddings and private events will also have live photo streams, dance parties and more */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-receipt icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Virtual Fun</h5>
                      <p className="text-muted mb-0">
                      It's a virtual event but we will still make it fun. Get excited for the new normal!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-heart icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Memories</h5>
                      <p className="text-muted mb-0">
                        We know it's not the same, but why not make it as memorable as possible.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state
}))(PromoSection);
